import { PROCESS_STATUS, PROCESS_STATUS_LIST } from 'consts/processStatus';
import type { ProcessesResponse } from 'types';
import { isCompany, toBucket } from './Admin.helpers';
import { AdminDrawerActions } from './AdminDrawerActions';
import { AdminDrawerHeader } from './AdminDrawerHeader';
import { AdminDrawerSigners } from './AdminDrawerSigners';
import { useAdminDrawer } from './useAdminDrawer';

type AdminDrawerProps = {
	onClose: () => void;
	onRefresh: () => void;
	row: ProcessesResponse;
};

export function AdminDrawer({ row, onClose, onRefresh }: Readonly<AdminDrawerProps>) {
	const drawer = useAdminDrawer(row, onClose, onRefresh);
	const { panelRef, selectedStatus, setSelectedStatus, t } = drawer;

	return (
		<div className="admin-drawer-backdrop">
			<div aria-label={t('update_process')} className="admin-drawer-panel" ref={panelRef} role="dialog">
				<AdminDrawerHeader busy={!!drawer.busy} onClose={onClose} row={row} t={t} />

				<div className="admin-drawer-body">
					<div className="admin-drawer-current-status">
						<span className="admin-drawer-current-status__label">{t('current_status')}</span>
						<span className={`admin-status admin-status--${toBucket(row.processStatus)}`}>
							{t(PROCESS_STATUS[row.processStatus])}
						</span>
					</div>

					<label className="admin-drawer-label" htmlFor="drawer-status">
						{t('update_process_status')}
					</label>
					<select
						className="admin-filter admin-drawer-select"
						id="drawer-status"
						onChange={e => setSelectedStatus(e.target.value)}
						value={selectedStatus}
					>
						{PROCESS_STATUS_LIST.map(key => (
							<option key={key} value={`${PROCESS_STATUS[key]}`}>
								{t(PROCESS_STATUS[PROCESS_STATUS[key]])}
							</option>
						))}
					</select>

					<AdminDrawerActions
						busy={drawer.busy}
						confirmCancel={drawer.confirmCancel}
						onConfirmCancel={drawer.onConfirmCancel}
						onSubmit={drawer.onSubmit}
						setConfirmCancel={drawer.setConfirmCancel}
						t={t}
					/>

					<AdminDrawerSigners isCompanyRow={isCompany(row.kennitala)} signers={drawer.signers} t={t} />
				</div>
			</div>
		</div>
	);
}
